import {
    ProtectionPlanTypes,
    REQUEST_PROTECTION_PLAN_IDF,
    RECEIVE_PROTECTION_PLAN_IDF,
    IProtectionPlanResponse,
    IProduct,
    IPackage,
    IPackageProduct,
    BillingInfoTypes,
    RECEIVE_BILLING_INFO,
    IBillingInfoResponse,
    ICancellationStatus,
} from "./types";
import { AppThunkAction } from "../..";
import * as services from "../../service";
import { protectionPlanIgnoredIDFServiceList, replaceIDFServiceName } from "../../../config/UserServicesList";
import moment from "moment-timezone";

export const actionCreators = {
    requestProtectionPlan:
        (forceFullyRefresh: boolean): AppThunkAction<ProtectionPlanTypes> =>
        (dispatch, getState) => {
            const appState = getState();

            let protectionPlanData: IProtectionPlanResponse;
            if (
                appState != null &&
                appState.protectionPlanIdfState != null &&
                ((appState.protectionPlanIdfState.protectionPlanData?.packageList == null && appState.protectionPlanIdfState.isLoading === false) ||
                    forceFullyRefresh === true)
            ) {
                services
                    .getIDFProtectionPlan()
                    .then((data) => {
                        services.GetIDFPackageCancellationStatus().then((cancelStatusData) => {
                            let cancellationStatus: ICancellationStatus = {
                                cancellationDate: cancelStatusData.cancelDate ? moment(cancelStatusData.cancelDate, "M/D/YYYY").format("M/D/YYYY") : null!,
                                processedDate: cancelStatusData.processed,
                                requestedDate: cancelStatusData.requestDate,
                            };
                            if (cancelStatusData.processed != null) {
                                data.packageInformation = [];
                            }

                            let packageList: IPackage[] = [];
                            let productList: IProduct[] = [];

                            if (data["status-code"] === "200") {
                                const packages: any[] = data.packageInformation;

                                // filtering and renaming products
                                packages.forEach((pkg: any, pkgIndex: number) => {
                                    pkg.Products.forEach((product: any, productIndex: number, productObj: any) => {
                                        /*if (protectionPlanIDFServiceList.includes(product.productName)) {*/
                                        if (!protectionPlanIgnoredIDFServiceList.includes(product.productName)) {
                                            packages[pkgIndex].Products[productIndex].productName = replaceIDFServiceName(product.productName);
                                        } else {
                                            // we are setting productName null here to ignore this product while making the product list
                                            productObj[productIndex].productName = null;
                                        }
                                    });
                                });

                                // sorting packages
                                packages.sort((a: any, b: any) => (parseFloat(b["upgrade-order"]) > parseFloat(a["upgrade-order"]) ? -1 : 1));

                                let currentPackage = packages.find((it: any) => it.isActive);

                                // preparing all products list
                                packages.forEach((pkg) => {
                                    pkg.Products.forEach((product: any) => {
                                        if (product.productName) {
                                            let foundProduct = productList.find((it) => it.name === product.productName);
                                            if (!foundProduct) {
                                                let tempProduct: IProduct = {
                                                    id: product.Id,
                                                    serviceCode:product.serviceCode,
                                                    name: product.productName,
                                                    productDescription: product.productDescription,
                                                    groupName: product.groupName,
                                                };
                                                productList.push(tempProduct);
                                            }
                                        }
                                    });
                                });

                                // preparing packages
                                packages.forEach((pkg) => {
                                    let productDifference: IPackageProduct[] = [];
                                    let packageProducts: IPackageProduct[] = [];

                                    // preparing package products list
                                    productList.forEach((product) => {
                                        let foundProduct = pkg.Products.find((it: any) => it.productName === product.name);
                                        let packageProduct: IPackageProduct;
                                        if (!foundProduct) {
                                            packageProduct = {
                                                id: product.id,
                                                serviceCode:product.serviceCode,
                                                productName: product.name,
                                                groupName: product.groupName,
                                                icon: "==cross==",
                                            };
                                        } else {
                                            packageProduct = {
                                                id: product.id,
                                                serviceCode: product.serviceCode,
                                                productName: product.name,
                                                groupName: product.groupName,
                                                icon: "==tick==",
                                            };
                                        }
                                        packageProducts.push(packageProduct);
                                    });

                                    // preparing package product difference list
                                    if (pkg.isActive) {
                                        productDifference = packageProducts;
                                    } else {
                                        pkg.Products.forEach((product: any) => {
                                            if (product.productName) {
                                                let foundProduct = currentPackage.Products.find((it: any) => it.productName === product.productName);
                                                if (!foundProduct) {
                                                    let differentProduct: IPackageProduct = {
                                                        id: product.Id,
                                                        serviceCode:product.servicCode,
                                                        productName: product.productName,
                                                        groupName: product.groupName,
                                                        icon: "",
                                                    };
                                                    productDifference.push(differentProduct);
                                                }
                                            }
                                        });
                                    }

                                    var tempPackage: IPackage = {
                                        id: pkg["id"],
                                        name: pkg["name"],
                                        code: pkg["code"],
                                        "annual-cost": parseFloat(pkg["annual-cost"]),
                                        "monthly-cost": parseFloat(pkg["monthly-cost"]),
                                        "upgrade-order": parseInt(pkg["upgrade-order"]),
                                        "upgrade-cost": parseFloat(pkg["upgrade-cost"]),
                                        "total-offer-cost": parseFloat(pkg["total-offer-cost"]),
                                        "billing-cycle": pkg["billing-cycle"],
                                        IsActive: pkg["isActive"],
                                        productDifference: productDifference,
                                        isCancellable: data["isCancellable"],
                                        isUserPaid: Boolean(data["isUserPaid"]),
                                        providedBy: pkg["providedBy"],
                                        products: packageProducts,

                                        /* for UI purpose */
                                        ActionButtonText: pkg["isActive"] ? "Cancel" : "Upgrade",
                                        Price: pkg["billing-cycle"]?.toUpperCase() === "YEARLY" ? pkg["annual-cost"] : pkg["monthly-cost"],
                                        DisplayCancelButton: pkg["isActive"] && data["isCancellable"] && !cancellationStatus.requestedDate,
                                    };
                                    packageList.push(tempPackage);
                                });

                                protectionPlanData = {
                                    packageList: packageList,
                                    productList: productList,
                                    cancellationStatus: cancellationStatus,
                                };
                                dispatch({ type: RECEIVE_PROTECTION_PLAN_IDF, protectionPlanData: protectionPlanData });
                            }
                        });
                    })
                    .catch(function (error) {
                        dispatch({ type: RECEIVE_PROTECTION_PLAN_IDF, protectionPlanData: protectionPlanData });
                    });

                dispatch({ type: REQUEST_PROTECTION_PLAN_IDF });
            }
        },

    requestBillingInfo:
        (forceLoad: boolean): AppThunkAction<BillingInfoTypes> =>
        (dispatch, getState) => {
            const appState = getState();
            if (
                appState &&
                appState.billingInfoState &&
                ((!appState.billingInfoState.billingInfoData && !appState.protectionPlanIdfState.isLoading) || forceLoad === true)
            ) {
                services
                    .GetPaymentDetail()
                    .then((data) => {
                        let billingInfoData: IBillingInfoResponse = {
                            creditCard: data.creditCard,
                            nextBillingDate: data.nextBillingDate,
                        };

                        dispatch({ type: RECEIVE_BILLING_INFO, data: billingInfoData });
                    })
                    .catch(function (error) {
                        // console.log(error);
                    });
            }
        },
};
